import { render } from "./TokenComp.vue?vue&type=template&id=60362b4f&scoped=true"
import script from "./TokenComp.vue?vue&type=script&lang=js"
export * from "./TokenComp.vue?vue&type=script&lang=js"

import "./TokenComp.vue?vue&type=style&index=0&id=60362b4f&scoped=true&lang=scss"

import exportComponent from "F:\\vue\\raven\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60362b4f"]])

export default __exports__